import { ItemDelegate } from '@leverege/molten/imagine';
import { GlobalState } from '@leverege/ui-redux';
import { isAssetPaired } from "../../../util/Relationship.js";
export default {
  id: 'imagine.pairing.onOpen',
  type: 'imagine.pairing.onOpen',
  perform: async opts => {
    const {
      setActiveStep,
      context,
      onChange
    } = opts;
    const {
      target,
      relationship,
      attribute,
      tagDelegate
    } = context;
    const change = {
      data: {
        'asset/obj': 'asset'
      },
      value: {
        asset: {
          ...target
        }
      }
    };
    if (target) {
      if (isAssetPaired(target, relationship)) {
        const tagId = attribute.get(target.data);
        const tag = ItemDelegate.getItem(tagId);
        if (tagId && !tag) {
          try {
            await GlobalState.dispatch(tagDelegate.item(tagId).get());
          } catch (err) {
            console.warn(err, 'unable to load child tag device');
          }
        }
        if (ItemDelegate.getItem(tagId)) {
          const tagObj = {
            id: tagId,
            type: relationship.objectType,
            ref: tagDelegate.getInterfaceUrl(),
            data: ItemDelegate.getItem(tagId)
          };
          change.data['tag/obj'] = 'tag';
          change.value.tag = tagObj;
        }
        setActiveStep('selectUnpair');
      } else {
        setActiveStep('selectPairAsset');
      }
      onChange(change);
    }
  }
};